import { browser } from '$app/environment';
import { GENERIC_ERROR } from '$lib/constants/text';
import Logger from '$lib/utils/logger';

const OFFLINE_ERROR = 'You are offline, please connect to internet.';

/* API Requester */
async function httpRequester<T>(url: string, config: RequestInit): Promise<T> {
  try {
    if (browser && !navigator.onLine) {
      throw new Error(OFFLINE_ERROR);
    }

    const request = new Request(url, config);
    const response = await fetch(request);
    if (!response.ok) {
      const error = await response.text();
      throw new Error(error);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    Logger.error('Error in requester:', error);
    throw new Error((error as Error)?.message || GENERIC_ERROR);
  }
}

const defaultHeaders = {
  headers: {
    'Content-Type': 'application/json'
  }
};

export async function get<T>(url: string, config?: RequestInit): Promise<T> {
  const init = { method: 'GET', ...config };
  return httpRequester<T>(url, init);
}

export async function post<T, U>(url: string, body: T, config?: RequestInit): Promise<U> {
  const init = {
    method: 'POST',
    body: JSON.stringify(body),
    ...defaultHeaders,
    ...config
  };
  return httpRequester<U>(url, init);
}
